const LoadWizardHeader = ({ step, totalSteps }) => (
  <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-6">
    <div>
      <h1 className="text-2xl font-semibold text-cs-dark">Create load</h1>
      <p className="text-sm text-cs-muted mt-1">
        Configure the load details in three simple steps.
      </p>
    </div>

    <div className="px-3 py-1.5 rounded-xl bg-cs-bg border border-cs-border text-[11px] text-cs-muted">
      Step{" "}
      <span className="font-semibold text-cs-dark">
        {step}
      </span>{" "}
      of {totalSteps}
    </div>
  </div>
);

export default LoadWizardHeader;
